import { SVGProps } from "react";

const CryptoBridgeIcon = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="4" cy="12" r="2.5" />

      <circle cx="20" cy="12" r="2.5" />

      <path d="M4 12 Q12 4 20 12" />

      <path d="M10 9l2-2 2 2" />
      <path d="M14 15l-2 2-2-2" />
    </svg>
  );
};

export default CryptoBridgeIcon;
